import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
  deleteOperacaoMedicaoTemperatura,
} from './actions';

export function* requestOperacaoMedicaoTemperaturas({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'medicaotemperaturas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaomedicaotemperatura, params } = payload;

    yield call(api.post, 'medicaotemperaturas', operacaomedicaotemperatura);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/medicaotemperatura');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `medicaotemperaturas/${id}`);

    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaomedicaotemperatura, params } = payload;

    yield call(api.put, 'medicaotemperaturas', operacaomedicaotemperatura);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/medicaotemperatura');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'medicaotemperaturas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyUpdate({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'medicaotemperaturas/altera', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/medicaotemperatura');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaomedicaotemperatura/OPERACAOMEDICAOTEMPERATURAS_IN_REQUEST',
    requestOperacaoMedicaoTemperaturas
  ),
  takeLatest(
    '@operacaomedicaotemperatura/DELETE_OPERACAOMEDICAOTEMPERATURA',
    deleteOperacaoMedicaoTemperatura
  ),
  takeLatest(
    '@operacaomedicaotemperatura/SUCCESS_REMOVE',
    requestOperacaoMedicaoTemperaturas
  ),
  takeLatest(
    '@operacaomedicaotemperatura/STORE_OPERACAOMEDICAOTEMPERATURA',
    store
  ),
  takeLatest(
    '@operacaomedicaotemperatura/FIND_OPERACAOMEDICAOTEMPERATURA',
    find
  ),
  takeLatest(
    '@operacaomedicaotemperatura/UPDATE_OPERACAOMEDICAOTEMPERATURA',
    update
  ),
  takeLatest('@operacaomedicaotemperatura/RECORD_FILTERING', applyedFilters),
  takeLatest('@operacaomedicaotemperatura/UPDATE', applyUpdate),
]);
